module.exports = __webpack_public_path__ + "static/media/giftcard-holiday-mobile.602254f4.png";